// VERTRAG
export const STATUS_VALUES = ['aktiv', 'invitatio', 'aufgehoben', 'gekündigt', 'erloschen', 'nichteinlösung', 'stillgelegt', 'abgelehnt'];
export const MAHNSTATUS_VALUES = ['0', '1', '2'];

// SCHADEN
export const DECKUNGSZUSAGE_VALUES = ['abgelehnt', 'erteilt', 'offen'];
export const ERLEDIGT_VALUES = [{ text: 'geschlossen', value: 'ja' }, { text: 'offen', value: 'nein' }];
export const LEISTUNGSART_VALUES = [
  {value: 'p', text: 'Privat'},
  {value: 'g', text: 'Gewerbe'},
  {value: 'l', text: 'Landwirtschaft'},
  {value: 'k', text: 'Medizin'},
  {value: 'v', text: 'Vereins-RS'},
  {value: '01', text: 'Verkehrs-RS'},
  {value: '50', text: 'Opfer-RS'},
  {value: '51', text: 'Allg. Straf-RS'},
  {value: '52', text: 'Allg. Schadeners.-RS'},
  {value: '53', text: 'Arbeits-RS'},
  {value: '54', text: 'Sozialger.-RS'},
  {value: '55', text: 'Beratungs-RS'},
  {value: '56', text: 'Allg. Vertrags-RS'},
  {value: '57', text: 'Handelsvert.-RS'},
  {value: '58', text: 'Allg. Vers.-Vertrags-RS'},
  {value: '59', text: 'Steuer-RS'},
  {value: '60', text: 'Allg. Verwalt.-RS'},
  {value: '61', text: 'Allg. Schadeners.-RS'},
  {value: '62', text: 'Arbeits-RS'},
  {value: '63', text: 'Allg. RS im Vertrags- und Sachenrecht'},
  {value: '64', text: 'Allg. Steuer-RS'},
  {value: '65', text: 'Sozial-RS'},
  {value: '66', text: 'Allg. Verwaltungs-RS'},
  {value: '67', text: 'Diszip.- und Standes-RS'},
  {value: '68', text: 'Allg. Straf-RS'},
  {value: '69', text: 'Allg. Ordwidrigk.-RS'},
  {value: '70', text: 'Beratungs-RS im Fam.- und Erbrecht'},
  {value: '71', text: 'Opfer-RS'},
  {value: '81', text: 'Wohngs- und Grundst.-RS'},
  {value: '84', text: 'Wohngs- und Grundst.-Steuer-RS'},
  {value: '98', text: 'Grundst.-Steuer-RS'},
  {value: '99', text: 'Grundst./Miet-RS'}
];
export const LEISTUNGSART_KEYMAP = { from: ['01','02','03','04','05','06','11','13','14','16','18','19'], to: '01'};

// ANGEBOT
export const ANGEBOTSART_VALUES = [ 'Vorschlag', 'Angebot'];

export const AENDERUNG_PAGE_NAMES = {
  versicherungsnehmer: "VN",
  mitversichertePerson: "MVP",
  zahlungsart: "BANK",
  umfang: "RISIKO"
};

export const PRODUKTE_VALUES = [
  {code: 'G0001', text: 'KOMPEX'},
  {code: 'G0002', text: 'Gewerbe-RS'}
];
